import { StationLabel } from '@app/modules/admin/screens/stations/list/StationLabel';
import { HTMLAttributes } from 'react';
import { QUALITY_TIMELINE } from '../../consts';
import { MinimumStation, Station } from '@app/core/types/stations';

export type TimelineStationTickLabelProps = {
  /** SVG x coordinate where the label block should end (same as visx left-axis tick label, text-anchor end). */
  anchorX: number;
  /** SVG y coordinate for vertical alignment with the band row center. */
  anchorY: number;
  /** Width reserved for avatar + name; defaults to `QUALITY_TIMELINE.stationTickLabelWidth`. */
  width?: number;
  /** Bold station name when a timeline bar for this station is hovered. */
  nameEmphasized?: boolean;
  station: Station | MinimumStation;
};

/**
 * Embeds `StationLabel` (avatar + name) in the timeline SVG via `foreignObject`, for visx `tickComponent`.
 */
export function TimelineStationTickLabel({
  anchorX,
  anchorY,
  width = QUALITY_TIMELINE.stationTickLabelWidth,
  nameEmphasized = false,
  station,
}: TimelineStationTickLabelProps) {
  const height = 28;

  return (
    <foreignObject
      x={anchorX - width}
      y={anchorY - height / 2}
      width={width}
      height={height}
      style={{ overflow: 'hidden', pointerEvents: 'none' }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          minWidth: 0,
          margin: 0,
          paddingRight: 4,
          boxSizing: 'border-box',
        }}
        {...({
          xmlns: 'http://www.w3.org/1999/xhtml',
        } as HTMLAttributes<HTMLDivElement>)}
      >
        <div style={{ minWidth: 0, maxWidth: '100%' }}>
          <StationLabel emphasized={nameEmphasized} station={station} singleLineEllipsis />
        </div>
      </div>
    </foreignObject>
  );
}
